angular.module('elogbooksServices').factory('UserToken', ['$resource',



]);
